import React from 'react'
import styled from '@emotion/styled'

import { Image } from './Image'
import { cssImageStyle, cssImageWrapper, cssRecipeImageAndCookingTimeWrapper } from './styles'
import { Recipe } from '@library/menu-service'

const ImageWrapper = styled.div(
  () =>
    ({
      ...cssImageWrapper,
      label: '-TileImage',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any),
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ContentWrapper = styled.div(cssRecipeImageAndCookingTimeWrapper as any)

export function TileImage({
  lazy,
  recipe,
  insideOverflow = false,
  decorative = false,
  testId,
}: {
  lazy: boolean
  recipe: Pick<Recipe, 'images' | 'name'>
  insideOverflow?: boolean
  decorative?: boolean
  testId?: string
}) {
  return (
    <ImageWrapper>
      <ContentWrapper>
        <Image
          lazy={lazy}
          styles={cssImageStyle}
          recipe={recipe}
          insideOverflow={insideOverflow}
          decorative={decorative}
          testId={testId}
        />
      </ContentWrapper>
    </ImageWrapper>
  )
}
